<template>
  <el-row v-if="single">
    <el-col :md="8" :xs="24">
      <trade-distribution :height="height" ref="trade"
        :show-title="single"></trade-distribution></el-col>
    <el-col :md="8" :xs="24">
      <project-nation :height="height" ref="nation"
        :show-title="single"></project-nation>
    </el-col>
    <el-col :md="8" :xs="24">
      <project-count :height="height" ref="count"
          :show-title="single"></project-count>
    </el-col>
  </el-row>

</template>

<script>
import TradeDistribution from './trade_distribution.vue'
import ProjectNation from './project_nation.vue'
import ProjectCount from './project_count.vue'
export default {
  name: 'pbrChartProjectIndex',
  props: {
    single: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      require: true
    }
  },
  data(){
    return {
      height: 200
    }
  },
  components: {
    TradeDistribution,
    ProjectNation,
    ProjectCount
  },
  methods: {
    projectNationChartClick (name) {
      debugger
      // this.$emit('update:emphasesCategory', 'project')
    },
    projectCountChartClick (name) {
      debugger
      // this.$emit('update:emphasesCategory', 'project')
    },
    tradeDistributionChartClick (name) {
      debugger
      // this.$emit('update:emphasesCategory', 'project')
    },
    resize () {
      this.$refs.count && this.$refs.count.resize()
      this.$refs.nation && this.$refs.nation.resize()
      this.$refs.trade && this.$refs.trade.resize()
    }
  },
  mounted () {
    window.addEventListener('resize', this.resize)
    let bodyStyle = window.getComputedStyle(document.body)
    let computedStyle = window.getComputedStyle(document.querySelector('.pbr-index-charts'))
    this.height = Math.min(parseFloat(computedStyle.height), parseFloat(computedStyle.width))
    if (parseInt(bodyStyle.width) < 992) {
      this.height = parseFloat(computedStyle.height) / 3 - 20
    }
  },
  destroyed () {
    window.removeEventListener('resize',this.resize)
  },
}
</script>

<style lang="scss" scoped>
</style>
